import numeral from "numeral";

import { StyledLink } from "../../../../styled components/StyledLink/src/StyledLink";

import { NumberRow } from "./StyledComponents";

const CoreNumberCell = ({
    value,
    row,
    format,
    getLink,
    onTrack,
    bold,
    highlighted,
    prefix = "",
    suffix = "",
}: ICoreNumberCellProps) => {
    const result = value ? prefix + numeral(value).format(format) + suffix : "N/A";
    return getLink ? (
        <NumberRow>
            <StyledLink
                href={getLink(row)}
                onClick={() => onTrack?.(row)}
            >
                {result}
            </StyledLink>
        </NumberRow>
    ) : (
        <NumberRow
            bold={bold}
            highlighted={highlighted}
        >
            {result}
        </NumberRow>
    );
};
CoreNumberCell.displayName = "CoreNumberCell";

interface ICoreNumberCellProps {
    value: number;
    row?: any;
    format?: string;
    getLink?: (row: FixmeType) => string;
    onTrack?: (a?: FixmeType, b?: FixmeType, c?: FixmeType, d?: FixmeType) => void;
    bold?: boolean;
    prefix?: string;
    suffix?: string;
    highlighted?: boolean;
}

export default CoreNumberCell;
